import { Query } from 'acast-reactor';
import request from 'superagent';
import { getUserToken } from 'services/authentication';
import Config from 'app/config';

export default Query.define('userprofile/read', {
  cache: false,

  execute: () =>
    new Promise((resolve, reject) => {
      const API_HOST = Config.get('CREATE_API_HOST');

      request
        .get(`${API_HOST}/api-v2/user/profile`)
        .set('Authorization', `Bearer ${getUserToken()}`)
        .end((err, res) => {
          if (err) {
            if (err.status === 401) {
              window.location.assign('/logout');
            }

            return reject(err);
          }
          return resolve(res.body);
        });
    }),
});
